// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8ca19e2e","239":"9c81c76f","453":"8d6b5a8e","455":"213eab2a"}[chunkId] + ".chunk.js";
};